import { useEffect, useState } from 'react';

import { Dialog, DialogBody } from '@/components/ui/catalyst/dialog';
import { Z_INDEX_MODAL_BASE, Z_INDEX_MODAL_HIGH } from '@/components/ui/zIndex';

import { RequestPage } from '../RequestPage';

interface RequestModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  requestId: string;
  providerId: string;
  highZIndex?: boolean;
}

export const RequestPageModal = ({
  isOpen,
  setIsOpen,
  requestId,
  providerId,
  highZIndex = false,
}: RequestModalProps) => {
  const [layoutMode, setLayoutMode] = useState<'default' | 'review'>('review');

  // Ensure ESC key closes the modal
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, setIsOpen]);

  useEffect(() => {
    if (!isOpen) {
      setLayoutMode('review');
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className={
        layoutMode === 'default'
          ? 'sm:max-w-[1520px]! overflow-hidden !rounded-2xl !p-0'
          : 'sm:max-w-[980px]! overflow-hidden !rounded-2xl !p-0'
      }
      zIndex={highZIndex ? Z_INDEX_MODAL_HIGH : Z_INDEX_MODAL_BASE}
    >
      <DialogBody className="!mt-0 h-[min(968px,95vh)] overflow-hidden">
        <RequestPage
          requestId={requestId}
          providerId={providerId}
          onClose={() => setIsOpen(false)}
          onLayoutModeChange={setLayoutMode}
        />
      </DialogBody>
    </Dialog>
  );
};
